import React from 'react';
import CheckIcon from '@material-ui/icons/Check';

export const renderBooleanIcon = (value) =>
  value ? <CheckIcon fontSize="small" style={{ color: 'var(--evidence-text)' }} /> : null;

export const renderBooleanText = (value) => (value ? 'Yes' : 'No');